<!-- Button -->
<button mat-icon-button [matMenuTriggerFor]="languages">
    <img
        class="w-6 h-6"
        [src]="'images/flags/' + activeLang() + '.svg'"
        alt="Selected Language"
    />
</button>

<mat-menu [xPosition]="'before'" #languages="matMenu">
    @for (lang of availableLangs(); track $index) {
        <button mat-menu-item (click)="setActiveLang(lang.code)">
            <span class="flex items-center">
                <span class="relative w-6 overflow-hidden rounded-sm shadow">
                    <span
                        class="absolute inset-0 ring-1 ring-inset ring-black ring-opacity-10"
                    ></span>
                    <img
                        class="w-full"
                        [src]="'images/flags/' + lang.code + '.svg'"
                    />
                </span>
                <span class="ml-3">{{ lang.name }}</span>
            </span>
        </button>
    }
</mat-menu>

